<div class="row mt-3 mx-0">
  <div class="col-sm-12 offset-sm-0 col-lg-10 offset-lg-1">
    <div class="about-us-wrapper">
      <div class="about-us-content">
        <div class="commitment-wrapper">
          <div class="commitment-content">
            <div class="row">
              <div class="col-md-12">
                <h1 class="harmony-secondary-text fw-bold">
                  Our Commitment to Sustainability
                </h1>
              </div>
            </div>
            <div class="row harmony-accent-grey-text">
              <div class="col-md-12">
                <p>
                  We are committed to working in harmony with the environment we live in. All companies within the <span
                    class="registered">Harmony</span> Relocation Network strive to take their corporate & social
                  responsibilities seriously. Whilst we all focus on building our companies, we do that in a socially
                  responsible, ethical and sustainable way. Our clients recognise this in everything we do, from our
                  policies, the people we employ and the partners we work with.
                </p>
                <p>
                  We uphold all global & local regulations on Health, Safety, Quality, Compliance, GDPR, Sustainability
                  and Environment. We are committed to continuously developing future-proof standards and delivering
                  them without compromise. You can be assured that our services are safe, reliable and of excellent
                  quality and that business is conducted in a sustainable way from environmentally friendly to socially
                  responsible.
                </p>
                <p>
                  Doing the right thing is second nature to us.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="commitment-images">
                  <img class="commitment-image image-1" src="../../../../assets/shapes/teal/hex-sm.svg" alt="" />
                  <img class="commitment-image image-2" src="../../../../assets/shapes/purple/long-hex-horizontal.svg"
                    alt="" />
                  <img class="commitment-image image-3"
                    src="../../../../assets/images/shaped/long-horizontal-people-3.png" alt="" />
                </div>
              </div>
            </div>
            <div class="row code-row mt-5">
              <div class="col-md-12">
                <h1 class="harmony-secondary-text fw-bold">
                  Our code | The way we work
                </h1>
              </div>
            </div>
            <div class="row harmony-accent-grey-text">
              <div class="col-md-12">
                <p>
                  Harmony’s <a [href]="CodeOfConductDocumentUrl" target="_blank" class="harmony-secondary-link"><span
                      class="harmony-accent-coral-text"><b class="text-decoration-underline">Code of
                        Conduct</b></span></a> sets out our commitment to ethics and integrity and states how you (as
                  assignee, client, partner), can expect our network members to behave to ensure we always try our best
                  to do the right thing. It is our ambition that any negative impact of our activities on the world will
                  be reduced as much as possible, if possible, to zero, and that our network and its participants
                  contribute to a better social climate in their area of influence.
                </p>
              </div>
              <div class="row harmony-accent-grey-text">
                <!-- Health & safety -->
                <div class="col-md-3 col-sm-12">
                  <div class="row">
                    <div class="col-12 text-center card-icon">
                      <a class="commitment-link" (click)="openCommitmentModal(commitmentModal, commitmentSections[0])">
                        <img class="client-image image-2 commitment-icon" [src]="commitmentSections[0].imagePath"
                          width="150" height="160" alt="Health & safety" />
                      </a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h5 class="harmony-primary-text fw-bold commitment-title"
                        (click)="openCommitmentModal(commitmentModal, commitmentSections[0])">
                        Health & safety
                      </h5>
                    </div>
                  </div>
                  <div class="row services-content">
                    <div class="col-12 text-center">
                      <p class="harmony-accent-grey-text">
                        Taking care of our employees
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Environment -->
                <div class="col-md-3 col-sm-12">
                  <div class="row">
                    <div class="col-12 text-center card-icon">
                      <a class="commitment-link" (click)="openCommitmentModal(commitmentModal, commitmentSections[1])">
                        <img class="client-image image-2 commitment-icon" [src]="commitmentSections[1].imagePath"
                          width="150" height="160" alt="Environment" />
                      </a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h5 class="harmony-primary-text fw-bold commitment-title"
                        (click)="openCommitmentModal(commitmentModal, commitmentSections[1])">
                        Environment
                      </h5>
                    </div>
                  </div>
                  <div class="row services-content">
                    <div class="col-12 text-center">
                      <p class="harmony-accent-grey-text">
                        Preserve our world
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Ethical business -->
                <div class="col-md-3 col-sm-12">
                  <div class="row">
                    <div class="col-12 text-center card-icon">
                      <a class="commitment-link" (click)="openCommitmentModal(commitmentModal, commitmentSections[2])">
                        <img class="client-image image-2 commitment-icon" [src]="commitmentSections[2].imagePath"
                          width="150" height="160" alt="Ethical business" />
                      </a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h5 class="harmony-primary-text fw-bold commitment-title"
                        (click)="openCommitmentModal(commitmentModal, commitmentSections[2])">
                        Ethical business
                      </h5>
                    </div>
                  </div>
                  <div class="row services-content">
                    <div class="col-12 text-center">
                      <p class="harmony-accent-grey-text">
                        Being fair and honest
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Privacy protection -->
                <div class="col-md-3 col-sm-12">
                  <div class="row">
                    <div class="col-12 text-center card-icon">
                      <a class="commitment-link" (click)="openCommitmentModal(commitmentModal, commitmentSections[3])">
                        <img class="client-image image-2 commitment-icon" [src]="commitmentSections[3].imagePath"
                          width="150" height="160" alt="Privacy protection" />
                      </a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h5 class="harmony-primary-text fw-bold commitment-title"
                        (click)="openCommitmentModal(commitmentModal, commitmentSections[3])">
                        Privacy protection
                      </h5>
                    </div>
                  </div>
                  <div class="row services-content">
                    <div class="col-12 text-center">
                      <p class="harmony-accent-grey-text">
                        Using necessary data only
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Modal Template -->
                <ng-template #commitmentModal let-modal>
                  <div class="modal-header">
                    <h5 class="modal-title">
                      {{ selectedCommitment?.title }}
                    </h5>
                    <button type="button" class="btn-close" aria-label="Close"
                      (click)="modal.dismiss('Cross click')"></button>
                  </div>
                  <div class="modal-body">
                    <p class="harmony-accent-grey-text">{{ selectedCommitment?.content }}</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-primary harmony-primary-button"
                      (click)="modal.close('Close click')">Close</button>
                  </div>
                </ng-template>
              </div>
              <div class="row mt-5 content-row">
                <div class="col-md-12">
                  <h1 class="harmony-secondary-text fw-bold">
                    Our Quality | Upholding the highest service standards
                  </h1>
                  <p>
                    Our commitment to our staff, our customers, our work and sustainability has been laid down in the
                    international standards with which we comply.
                  </p>
                </div>
              </div>
              <div class="row mb-2 mt-4">
                <!-- ISO9001 -->
                <div class="col-sm-6 col-md text-center">
                  <fa-icon class="iso-icon" size="4x" [icon]="faQuality"
                    (click)="openIsoModal(isoModal, isoCertifications[0])"></fa-icon>
                  <h5 class="harmony-primary-text fw-bold commitment-title mt-4"
                    (click)="openIsoModal(isoModal, isoCertifications[0])">
                    ISO9001
                  </h5>
                  <p class="harmony-accent-grey-text">
                    Quality Management
                  </p>
                </div>
                <!-- ISO14001 -->
                <div class="col-sm-6 col-md text-center">
                  <fa-icon class="iso-icon" size="4x" [icon]="faEnvironment"
                    (click)="openIsoModal(isoModal, isoCertifications[1])"></fa-icon>
                  <h5 class="harmony-primary-text fw-bold commitment-title mt-4"
                    (click)="openIsoModal(isoModal, isoCertifications[1])">
                    ISO14001
                  </h5>
                  <p class="harmony-accent-grey-text">
                    Environmental Management
                  </p>
                </div>
                <!-- ISO45001 -->
                <div class="col-sm-6 col-md text-center">
                  <fa-icon class="iso-icon" size="4x" [icon]="faHealthSafety"
                    (click)="openIsoModal(isoModal, isoCertifications[2])"></fa-icon>
                  <h5 class="harmony-primary-text fw-bold commitment-title mt-4"
                    (click)="openIsoModal(isoModal, isoCertifications[2])">
                    ISO45001
                  </h5>
                  <p class="harmony-accent-grey-text">
                    Occupational Health & Safety Management
                  </p>
                </div>
                <!-- ISO27001 -->
                <div class="col-sm-6 col-md text-center">
                  <fa-icon class="iso-icon" size="4x" [icon]="faShield"
                    (click)="openIsoModal(isoModal, isoCertifications[3])"></fa-icon>
                  <h5 class="harmony-primary-text fw-bold commitment-title mt-4"
                    (click)="openIsoModal(isoModal, isoCertifications[3])">
                    ISO27001
                  </h5>
                  <p class="harmony-accent-grey-text">
                    Information Security Management System (ISMS)
                  </p>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-md-12">
                  <h1 class="harmony-secondary-text fw-bold">
                    Our Sustainability | Building a sustainable future together
                  </h1>
                </div>
                <div class="row harmony-accent-grey-text">
                  <div class="col-md-12">
                    <p>
                      The word harmony is synonymous with sustainability and in turn is reflected in the way that our
                      organisation
                      operates, how we look to leave behind a world where business is done in cooperation with the
                      environment around us
                      and not despite it. Being a cooperative network means that we deliver on equal business,
                      delivered at fair prices
                      and paid in a fair way, environmentally, socially and economically.
                    </p>
                  </div>
                </div>
              </div>
              <div class="row mt-5">
                <div class="col-md-2">
                  <!-- image trigger modal -->
                  <img src="../../../assets/branding/un.png" class="company-image" data-bs-toggle="modal"
                    data-bs-target="#unModal" width="100" alt="logo" />
                </div>
                <div class="col-md-2">
                  <img src="../../../assets/branding/b1g1.png" class="company-image" data-bs-toggle="modal"
                    data-bs-target="#b1g1Modal" width="100" alt="logo" />
                </div>
              </div>
              <!-- Modal -->
              <div class="modal modal-lg fade" id="unModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="exampleModalLabel">UN global compact</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-10">
                          Harmony has aligned to the UN Global Compacts 10 principles since 2023. These principles
                          focus on human rights, labour, environment, and anti-corruption, guiding businesses towards
                          responsible practices. As a guiding framework for business practices and supply chain
                          management, Harmony is a dedicated member to
                          <a href="https://unglobalcompact.org/" target="_blank" class="harmony-secondary-link"><span
                              class="harmony-accent-coral-text"><b class="text-decoration-underline">The UN Global
                                Compact.
                              </b></span></a>
                        </div>
                        <div class="col-md-2">
                          <img src="../../../assets/branding/un.png" width="100" alt="logo" />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary harmony-primary-button"
                        data-bs-dismiss="modal">Close</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal modal-lg fade" id="b1g1Modal" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="exampleModalLabel">B1G1</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-10">
                          Giving back to the global community we work around is a key part of what makes Harmony
                          Relocation the network that it is. To highlight our commitment to this fact we have
                          partnered with <a href="https://b1g1.com/" target="_blank"
                            class="harmony-secondary-link"><span class="harmony-accent-coral-text"><b
                                class="text-decoration-underline">
                                B1G1
                              </b></span></a>, an organisation focused on connecting business with projects around the
                          world giving back to the people that need it the most. By aligning the positive impacts made
                          to the UN Sustainability Development Goals, we can visually show our efforts towards a
                          sustainable future.

                        </div>
                        <div class="col-md-2">
                          <img src="../../../assets/branding/b1g1.png" width="100" alt="logo" />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary harmony-primary-button"
                        data-bs-dismiss="modal">Close</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ISO Modal Template -->
              <ng-template #isoModal let-modal>
                <div class="modal-header">
                  <h5 class="modal-title">
                    {{ selectedIsoTitle }}
                  </h5>
                  <button type="button" class="btn-close" aria-label="Close"
                    (click)="modal.dismiss('Cross click')"></button>
                </div>
                <div class="modal-body">
                  <p class="harmony-accent-grey-text">{{ selectedIsoContent }}</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-primary harmony-primary-button"
                    (click)="modal.close('Close click')">Close</button>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="mission-wrapper">
            <div class="mission-container">
              <p class="mission-header">
                Mission
              </p>
              <p class="mission-text">
                <span class="registered">Harmony</span> Relocation Network’s mission is to provide superior relocation
                services to customers around the world,
                using the combined skills and strengths of our independent member companies worldwide. We strive to do
                so in
                harmony with the world we operate in, and we operate ethically as a business. We consider the health
                and
                safety
                of our employees and customers, and the environmental impact of our work. We acknowledge the rights of
                workers
                to earn a fair wage, and we ensure that data privacy of our customers is respected at all times. In
                everything
                we do, we try to do the right thing.
                <br>
                <br>
                We challenge and support our network partners to continually improve their businesses and their
                services, with
                a constant focus on customer experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>